import {Dropdown, Menu, Avatar} from 'antd';
import moment from 'moment/moment';
import React, {FC} from 'react';

import {RichTextRenderer} from 'components/rich-text';
import {ReactComponent as MoreIcon} from 'shared/assets/more.svg';
import {DATE_WITH_TIME_DOTS_SECONDS_24, RESOLVED_FORMATS} from 'shared/constants/date-format';
import {
    ITableReportDocumentCommentDto,
} from 'store/slices/table-report-slice/table-report-attachments/table-report-attachments-types';

import styles from './comment-field.module.less';

interface ICommentFieldProps {
    commentData: ITableReportDocumentCommentDto;
    handleEdit: (data: ITableReportDocumentCommentDto) => void;
    handleDelete: (id: number) => void;
    isEditDisabled?: boolean;
    isDeleteDisabled?: boolean;
    avatarColor?: string;
}

export const CommentField: FC<ICommentFieldProps> = ({
    commentData,
    handleEdit,
    handleDelete,
    isEditDisabled,
    isDeleteDisabled,
    avatarColor,
}: ICommentFieldProps) => {
    const userName = commentData.fullName;
    const formattedDate = moment(commentData.createdDate, RESOLVED_FORMATS).format(DATE_WITH_TIME_DOTS_SECONDS_24);

    return (
        <div className={styles.wrapper}>
            <Avatar
                className={styles.avatar}
                style={{backgroundColor: avatarColor ?? '#1F487E'}}
            >
                {userName?.split(' ')
                    ?.map(symbol => symbol[0])
                    .join('')
                    ?.toUpperCase()}
            </Avatar>
            <div className={styles.comment}>
                <div className={styles['comment-title']}>
                    {userName}
                    {moment.isDate(formattedDate) ? ` - ${formattedDate}` : ''}
                    {commentData.updated && ' - отредактировано'}
                </div>
                <RichTextRenderer
                    classNames={{
                        wrapperClassName: styles['comment-body'],
                    }}
                    value={commentData.comment}
                />
            </div>
            {(!isEditDisabled || !isDeleteDisabled) && (
                <Dropdown
                    className={styles.dropdown}
                    overlay={(
                        <Menu
                            selectable={false}
                        >
                            {!isEditDisabled && (
                                <Menu.Item onClick={() => handleEdit(commentData)}>
                                    Редактировать
                                </Menu.Item>
                            )}
                            {!isDeleteDisabled && (
                                <Menu.Item onClick={() => handleDelete(commentData.id)}>
                                    Удалить
                                </Menu.Item>
                            )}
                        </Menu>
                    )}
                >
                    <div className={styles['dropdown-icon-wrapper']}>
                        <MoreIcon
                            className={styles['dropdown-icon']}
                        />
                    </div>
                </Dropdown>
            )}
        </div>
    );
};
